import React, { useState, useEffect } from "react";
import {
  Tabs,
  Button,
  Drawer,
  message,
  Badge,
  Card,
} from 'antd';
import Styled from 'styled-components';
import { FileAddFilled } from '@ant-design/icons'
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import moment from 'moment';

import { actions } from '../../../../../store/reducers/project';
import { actions as authActions } from '../../../../../store/reducers/authentication';
import ProjectCreate from '../../../../../components/Forms/projects/create';
import { canViewFeatureAction } from "../../../../../constants/roles";
import { findOptions } from "../../../../../helpers/StringHelper";
import Table from '../../../../../components/Table';
import { getHeaderColumns } from './../../../../../components/Forms/projects/index';
import { getProject } from "../../../../../services/BaseService";
import { DrawerHeader } from "datastake-daf/dist/components";
import { CREATE_DRAWER_WIDTH } from "../../../../../helpers/form";

const mstp = ({ pme, authentication, location, project }) => ({ pme, authentication, location, project });

const Styles = Styled.div`
  width: 100%;
  height: 100%;
  padding: 0 20px 0 20px;
  .projects-container {
    // padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    .ant-card {
      width: calc(100% / 4 - 15px);
      height: 240px;
      margin-right: 20px;
      margin-bottom: 20px;
      .actions {
        margin-top: 12px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }
    .ant-card-head {
      border-top: 4px solid #001529;
      border-bottom: none;
      .ant-card-head-title {
        color: #001529;
        font-weight: 800;
      }
    }
    .ant-card-body {
      padding-top: 0;
      p {
        margin-bottom: 5px;
      }
      strong {
        font-weight: 800;
      }
    }
    .ant-card:not(.selected) {
      .ant-card-extra {
        a {
          color: var(--mmt-primary-70);
        }
      }
    }
    .ant-card:nth-of-type(4) {
      margin-right: 0;
    }
    .ant-card.selected {
      border: 1px solid var(--mmt-primary-70);
    }
    .new-project {
      width: calc(100% / 4 - 15px);
      height: 240px;
      font-size: 20px;
      span {
        font-size: 22px;
        margin-bottom: 10px;
      }
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: none;
      border: 1px dotted var(--mmt-primary-70);
      border-radius: 4px;
      color: var(--mmt-primary-70);
      margin-right: 0;
    }
  }
`;

function PMEProjectLoad({
  authentication: { selectedProject, user },
  project: { data: { projects: data, options: projectOptions } },
  ProjectsGet,
  ResetProjectForm,
  ChangeProjectStatus,
  changeSelectedProject
}) {
  const { t } = useTranslation();
  const { search } = useLocation();
  const goTo = useNavigate();
  const columns = getHeaderColumns(t, goTo, ChangeProjectStatus);
  const [projects, setProjects] = useState([]);
  const [createVisible, setCreateVisible] = useState(
    search.indexOf('create') !== -1 || search.indexOf('edit') !== -1
  );
  const [currentProject, setCurrentProject] = useState(getProject());
  const canEdit = !user?.company?.id && (canViewFeatureAction({
    user,
    module: 'pme',
    feature: 'projects',
    action: 'create'
  }) || canViewFeatureAction({
    user,
    module: 'pme',
    feature: 'projects',
    action: 'edit'
  }));


  useEffect(() => {
    ProjectsGet({ namespace: 'PMEProject', module: 'pme', view: 'project' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCurrentProject(selectedProject);
  }, [selectedProject])

  useEffect(() => {
    if (data && Array.isArray(data)) {
      const { countries } = projectOptions || {};
      setProjects(data.map(project => {
        return {
          dbId: project.id,
          projectId: project.datastakeId,
          country: project.country ? findOptions(project.country, countries) : '-',
          status: project.status ? project.status : null,
          name: project.name ? project.name : '',
          dataClient: project.name && project.surname ? `${project.name} ${project.surname}` : '-',
          lastUpdate: project.publishedAt ? moment(project.publishedAt).format('DD MMM YYYY') : '-',
          contactName: project.name ? project.name : '-',
        };
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const isSelected = (projectId) => !!currentProject && currentProject === projectId;

  return (
    <Styles>
      <Tabs
        defaultActiveKey="1"
        items={[
          {
            label: t("Projects"),
            key: '1',
            tabKey: '1',
            children: (
              <div className="projects-container">
                {Array.isArray(projects) && projects.filter(p => p.status === 'approved').map(project => (
                  <Card title={project.name} extra={
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    <a onClick={() => {
                      if (!isSelected(project.dbId)) {
                        localStorage.setItem('project', project.dbId);
                        setCurrentProject(project.dbId);
                        changeSelectedProject(project.dbId, project.dashboardView);
                        goTo('/app/pme');
                      }
                    }}>
                      {!isSelected(project.dbId) ? t("Select") : t("Current")}</a>
                  }>
                    <p><strong>{t("Project") + "ID"}</strong>: {project.projectId}</p>
                    <p><strong>{t("Country")}</strong>: {project.country}</p>
                    <p><strong>{t("Status")}</strong>: {project.stauts}</p>
                    <p><strong>{t("Last Update")}</strong>: {project.lastUpdate}</p>
                    <div className="actions">
                      <Button size="small" type="primary" onClick={() => {
                        goTo(`/app/pme/project/${project.projectId}`);
                      }}>{t('Open')}</Button>
                    </div>
                  </Card>
                ))}
                {canEdit ? <button className="new-project" onClick={() => {
                  ResetProjectForm({ view: "project" });
                  setCreateVisible(true);
                }}>
                  <FileAddFilled />
                  {t('New Project')}
                </button> : null}
              </div>
            )
          },
          canEdit ? {
            label: (
              <>{t("Invitations")}
                <Badge offset={[10, 0]} count={projects.filter(p => p.status === 'pending').length} />
              </>
            ),
            key: "2",
            tabKey: "2",
            children: (
              <Table
                rowSelection={null}
                style={{ marginTop: '12px' }}
                columns={columns.filter(c => c.invitation)}
                data={projects.filter(p => p.status === 'pending')}
                size="small"
                rowKey="projectId" />
            ),
          } : null,
        ]}
      />
      <Drawer
        destroyOnClose={true}
        title={<DrawerHeader title={t("Create Project")} />}
        open={createVisible}
        maskClosable={false}
        onClose={() => {
          setCreateVisible(false);
          ResetProjectForm({ view: ["project", "new"], module: "pme" })
          ProjectsGet({ namespace: 'Project', module: 'pme', view: 'project' });
        }}
        width={CREATE_DRAWER_WIDTH}
        bodyStyle={{ padding: 0 }}>
        <ProjectCreate
          showSaveAndNext={false}
          namespace="PMEProject"
          module="pme"
          view={["project", "new"]}
          edit={false}
          onSubmitted={() => {
            message.success(t('Information submitted successfully'));
          }}
          onCancel={() => setCreateVisible(false)} />
      </Drawer>
    </Styles >
  );
}


export default connect(mstp, { ...actions, ...authActions })(PMEProjectLoad);
